// Entry point for CLASS plugin build
// Import all JavaScript modules
import './coursegroups/coursegroups.js';
import './trialrequest/trialrequest.js';
import { startCalendar, startOpeningTimes } from './calendar/calendar.js';
import { startPriceChooser, startCoursePriceForAge } from './pricing/pricing.js';

// Preserve the public entry points used by PHP-generated inline shortcode scripts.
Object.assign(window, {
    startCalendar,
    startOpeningTimes,
    startPriceChooser,
    startCoursePriceForAge
});

// Import main SCSS (which includes all module styles)
import './class.scss';
